import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);

// Цвета берём из токенов темы, а не литералами: смена бренда не должна
// перекрашивать графики, а зелёный и оранжевый здесь значат то же, что
// на значках баланса — норма набрана или нет.
function themeColor(name, fallback) {
    if (typeof window === 'undefined') return fallback;
    const value = getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim();
    return value || fallback;
}

const CHART_COLORS = {
    get ok() { return themeColor('--theme-green', '#49BA61'); },
    get ng() { return themeColor('--theme-orange', '#FF5938'); },
    // Прежние имена: сервер мог отдать их из кэша страницы.
    get blue() { return CHART_COLORS.ok; },
    get red() { return CHART_COLORS.ng; },
};

function getChartOptions(data) {
    return {
        type: 'bar',
        data: {
            labels: data.labels,
            datasets: [{
                label: '',
                backgroundColor: data.backgroundColor.map(color => CHART_COLORS[color]),
                data: data.values,
                barPercentage: 0.7,
                borderWidth: 1,
                borderRadius: 5,
                borderSkipped: true,
            }],
        },
        options: {
            plugins: {
                legend: {
                    display: false
                },
                title: {
                    display: false
                },
                tooltip: {
                    enabled: true,
                    displayColors: false,
                    titleFont: { size: 16 },
                    bodyFont: { size: 14 },
                    cornerRadius: 20,
                    caretSize: 5,
                    padding: 20,
                    backgroundColor: '#222222',
                    titleFontStyle: 'normal',
                    titleMarginBottom: 10,
                    callbacks: {
                        label: function (context) {
                            var label = context.dataset.label || '';

                            if (label) {
                                label += ' ';
                            }
                            if (context.parsed.y !== null) {
                                label += new Intl.NumberFormat('ru-RU', { style: 'decimal' }).format(context.parsed.y);
                            }
                            return label += '% от нормы';
                        },
                        labelTextColor: function (context) {
                            return 'white';
                        }
                    }
                },
            },
            scales: {
                x: {
                    ticks: {
                        display: true,
                    }
                },
                y: {
                    ticks: {
                        display: true,
                        stepSize: 2,
                        autoSkip: true
                    }
                }
            }
        }
    };
}

export function initCompoundChart($) {
    $('.compound-chart').each(function() {
        const data = JSON.parse($(this).attr('data-chart-values'));
        const myChart = new Chart($(this), getChartOptions(data));
        myChart.update();
    });
}
